import { IMdlCustomDialogConfiguration, MdlDialogService } from '@angular-mdl/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Report } from '../../documents';
import { ActionsMenuColumn } from '../../shared/grid-columns';
import { ActionsMenuAgRendererComponent, ActionsMenuItem } from './../../covance-ag-grid/renderers/actions-menu-ag-renderer-base';
import { UploadDialogData, UPLOAD_DLG_DATA_TOKEN } from './category-upload-dialogs/base/upload-dialog-data';
import { FileEditComponent } from './category-upload-dialogs/file-edit/file-edit.component';
import { DocumentTranslationUploadComponent } from './category-upload-dialogs/translations/document-translation-upload.component';
import { HideDocumentDialogData, HIDE_DIALOG_DATA_TOKEN } from './hide-document-dialog-data';
import { HideDocumentComponent } from './hide-document.component';

@Component({
    selector: 'upload-actions-menu-ag-renderer',
    template: require('../../covance-ag-grid/renderers/actions-menu-ag-renderer-base.html'),
    styles: [require('../../covance-ag-grid/renderers/actions-menu-ag-renderer-base.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadActionsMenuAgRendererComponent extends ActionsMenuAgRendererComponent<Report> {

    constructor(private dialogService: MdlDialogService) {
        super();
    }

    public createMenuItems(data: Report, colDef: ActionsMenuColumn<Report>): ActionsMenuItem[] {
        const menuItems: ActionsMenuItem[] = [];

        const canUploadCategory = colDef.userPermissions && colDef.categoryId && colDef.userPermissions.canUploadCategory(colDef.categoryId);

        if (!data.category.isSiteActions() && canUploadCategory) {
            menuItems.push({
                title: 'Add Translations',
                onClick: () => {
                    this.uploadTranslations(data);
                }
            });
        }

        if (canUploadCategory) {
            menuItems.push({
                title: 'Edit File',
                onClick: () => {
                    this.editFile(data);
                }
            });
        }

        if (colDef.userPermissions && colDef.userPermissions.has('HideUnhideDocuments')) {
            menuItems.push({
                title: data.isHidden ? 'Unhide' : 'Hide',
                onClick: () => {
                    this.hideDocument(data);
                }
            });
        }

        return menuItems;
    }

    private uploadTranslations(report: Report) {
        const dialogData: UploadDialogData<Report> = {
            report: report,
            category: report.category
        };
        const configDialog: IMdlCustomDialogConfiguration = {
            component: DocumentTranslationUploadComponent,
            providers: [{
                provide: UPLOAD_DLG_DATA_TOKEN, useValue: dialogData
            }],
            styles: {
                'overflow': 'auto',
                'max-height': '90vh'
            },
            isModal: true,
            clickOutsideToClose: true
        };

        this.dialogService.showCustomDialog(configDialog);
    }

    private editFile(report: Report) {
        const dialogData: UploadDialogData<Report> = {
            report: report,
            category: report.category
        };
        const configDialog: IMdlCustomDialogConfiguration = {
            component: FileEditComponent,
            providers: [{
                provide: UPLOAD_DLG_DATA_TOKEN, useValue: dialogData
            }],
            styles: {
                'overflow': 'auto',
                'max-height': '90vh'
            },
            isModal: true,
            clickOutsideToClose: true
        };

        this.dialogService.showCustomDialog(configDialog);
    }

    private hideDocument(report: Report) {
        const dialogData: HideDocumentDialogData = {
            report: report
        };
        const configDialog: IMdlCustomDialogConfiguration = {
            component: HideDocumentComponent,
            providers: [{
                provide: HIDE_DIALOG_DATA_TOKEN, useValue: dialogData
            }],
            isModal: true,
            clickOutsideToClose: true
        };

        this.dialogService.showCustomDialog(configDialog);
    }
}